import { getFuelStatementData } from '_services/accountsServices/fuelStationServices';
import BootstrapTable from 'components/BootstrapTable'
import useDocumentTitle from 'hooks/useDocumentTitle';
import { AddEditVehicleDocumentsModal, AddOtherDocumentsModal } from 'modals';
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import StorageService from 'utils/StorageServices';
import { TiEdit } from "react-icons/ti";
import { FaRegTrashAlt } from 'react-icons/fa';
import moment from 'moment';
import toast from 'react-hot-toast';
import { deleteVehicleDocumentData, getVehicleDocumentsListData } from '_services/accountsServices/vehicleDocTypeServices';
import { UserContext } from 'context';
import { utils } from 'helper';
import { CommonModal, CustomPagination } from 'components'
import { AiOutlineEye } from 'react-icons/ai';
import './vehicleDocument.css'

const VehicleDocuments = ({ onDataFetch, vehicleNo }) => {
    useDocumentTitle("Truck Document | T360");

    let { id } = useParams();
    const { createDocument, setCreateDocument } = useContext(UserContext);
    const [VehicleDocumentsList, setVehicleDocumentsList] = useState([]);
    const [otherDocumentShow, setOtherDocumentShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        company_id: StorageService.getCompanyId(),
        limit: 25,
        offset: 1,
        search: '',
        vehicle_no: vehicleNo,
        // status: 1
    });

    const [count, setCount] = useState({
        total: 0,
        active: 0,
        expiring: 0,
        expired: 0,
    })

    const [isDelete, setIsDelete] = useState(false);

    const deleteHandler = (item) => {
        setIsDelete(item)
    }

    const submitDeleteVehicleDocType = async () => {
        setLoading(true);
        try {
            let object = {
                company_id: isDelete?.company_id,
                id: isDelete?._id,
            }
            const res = await deleteVehicleDocumentData(object);
            if (res?.responseCode == 200) {
                if (res?.responseMessage) {
                    toast.success(`${res?.responseMessage}`);
                }
                getDataVehicleDocumentList();
                setLoading(false);
                setIsDelete(false);
            } else {
                if (res?.responseMessage) {
                    toast.error(res?.responseMessage);
                }
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    let propsObject = {
        isOpen: isDelete,
        closeModal: setIsDelete,
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: submitDeleteVehicleDocType,
        isLoadding: loading,
    }

    const columns = [
        { header: "Document Type", accessor: "document_type" },
        { header: "Document Number", accessor: "document_number" },
        { header: "Issue Date", accessor: "issue_date" },
        { header: "Expiry Date", accessor: "expiry_date" },
        { header: "Status", accessor: "status" },
        { header: "Reminders", accessor: "reminders" },
        { header: "Actions", accessor: "actions" },
    ];

    const rowListData = (data) => {
        const listArray = data?.map((item, i) => {
            return {
                ...item,
                // document_type: <> {item?.doc_type_id?.name ? item?.doc_type_id?.name : (item?.name ? item?.name : '-')} </>,
                document_type: <span className='_tblText _style_ancer' onClick={() => setOtherDocumentShow({ ...item, editDocument: true, viewDocument: true })}> <a className='_avPointer'> {item?.doc_type_id?.name ? item?.doc_type_id?.name : (item?.name ? item?.name : '-')} </a> </span>,
                document_number: <> {item?.document_no ? item?.document_no : '-'} </>,
                issue_date: <> {item?.company_id ? moment(item?.issue_date).format('DD MMM YYYY') : <></>} </>,
                expiry_date: <> {item?.company_id ? moment(item?.expiry_date).format('DD MMM YYYY') : <></>} </>,
                status: <>
                    {item?.company_id ?
                        utils.isDateInPastOrToday(item?.expiry_date) ?
                            <div className='__vhl_dt_expired'>Expired</div> :
                            (utils.isTodayBetweenDates(item?.reminder_date ? item?.reminder_date : utils.getReminderDate(item?.expiry_date, 15), item?.expiry_date) ? <div className='__vhl_dt_exSoon'>Expiring Soon</div> : <div className='__vhl_dt_active'>Active</div>)
                        : <></>
                    }
                </>,
                reminders: <>{item?.company_id ? <p style={{ marginBottom: '0px', color: utils.isDateInPastOrToday(item?.expiry_date) ? '#FF5561' : utils.isTodayBetweenDates(item?.reminder_date ? item?.reminder_date : utils.getReminderDate(item?.expiry_date, 15), item?.expiry_date) ? '#FFB336' : '#48CA32' }}>{utils?.getTimeDifferenceFromToday(item?.expiry_date)}</p> : <></>}</>,
                actions: <>
                    {item?.company_id ?
                        <div style={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
                            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                <button className='__vd_edit' onClick={() => setOtherDocumentShow({ ...item, editDocument: true })}><TiEdit /></button>
                                <button className='__vd_delete' onClick={() => deleteHandler(item)}><FaRegTrashAlt /></button>
                            </div>
                        </div> :
                        <div className="_rSideBtn">
                            <button className="anime-btn _addComm_btn" onClick={() => setOtherDocumentShow({ doc_type_id: { label: item?.name, value: item?._id }, addDocument: true, vehicle_no: vehicleNo, isCategoryDisable: true })}> Add Document </button>
                        </div>}
                </>
                // expiry_date: <div> <button className='__addDetail_'> <span>+ Add Details</span> </button> </div>,
            }
        });
        return listArray;
    };

    const getDataVehicleDocumentList = async () => {
        setLoading(true);
        try {
            let object = {
                ...filter,
            }
            const res = await getVehicleDocumentsListData(object);
            if (res?.responseCode == 200) {
                setVehicleDocumentsList([...res?.data?.documents, ...res?.data?.unused_doc_types]);
                setLoading(false);
                setCount((s) => ({ ...s, total: res?.data?.document_count }))
                setTotalItems(res?.data?.document_count);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (StorageService.getCompanyId()) {
            getDataVehicleDocumentList();
        }
    }, [filter])

    useEffect(() => {
        if (createDocument === true) {
            setOtherDocumentShow({ addDocument: true, vehicle_no: vehicleNo })
        }
    }, [createDocument])

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    useEffect(() => {
        if (VehicleDocumentsList?.length > 0) {
            let active = 0;
            let expiring = 0;
            let expired = 0;

            VehicleDocumentsList?.forEach((item) => {
                let isExpiryDate = item?.expiry_date ? new Date(item?.expiry_date) : new Date();
                let isRemainderDate = item?.reminder_date ? item?.reminder_date : utils.getReminderDate(isExpiryDate, 15);
                if (item?.expiry_date && utils.isDateInPastOrToday(item?.expiry_date)) {
                    return expired++;
                }
                if (isRemainderDate && item?.expiry_date && utils?.isTodayBetweenDates(isRemainderDate, item?.expiry_date)) {
                    return expiring++;
                } else if (isRemainderDate && item?.expiry_date && !utils?.isTodayBetweenDates(isRemainderDate, item?.expiry_date)) {
                    return active++;
                }
            })
            setCount((s) => ({
                ...s,
                active: active,
                expiring: expiring,
                expired: expired,
            }))
        }
    }, [VehicleDocumentsList])

    useEffect(() => {
        setFilter((s) => ({ ...s, vehicle_no: vehicleNo }))
    }, [vehicleNo])

    return (
        <>
            <div className='__vhlMain_fx'>
                <div className='__bt_seprate'>
                    <div className='__vhl_inrFx'>
                        <p>Total Documents</p>
                        <h4> {count?.total > 0 ? count?.total : 0} </h4>
                    </div>

                    <div className='__vhl_inrFx'>
                        <p>Active Documents</p>
                        <h4> {count?.active > 0 ? count?.active : 0} </h4>
                    </div>

                    <div className='__vhl_inrFx'>
                        <p>Expiring Soon</p>
                        <h4> {count?.expiring > 0 ? count?.expiring : 0} </h4>
                    </div>

                    <div className='__vhl_inrFx'>
                        <p>Expired Documents</p>
                        <h4> {count?.expired > 0 ? count?.expired : 0} </h4>
                    </div>
                </div>

                <div className='__vhlDetail_tabLx'>
                    <BootstrapTable
                        tableClass="__vhl_dtTable"
                        columns={columns}
                        data={rowListData(VehicleDocumentsList?.length > 0 ? VehicleDocumentsList : [])}
                        isLoading={loading}
                    />

                    {totalItems > 0 ? <div className='paginationFt_avt'>
                        <CustomPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={filter.offset}
                            onPageChange={handlePageChange}
                        />
                    </div> : <></>}
                </div>
            </div>

            {/* {otherDocumentShow && <AddOtherDocumentsModal {...otherDocumentsProps} />} */}

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${otherDocumentShow ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: otherDocumentShow ? 'visible' : 'hidden' }}
            >
                {otherDocumentShow &&
                    <AddEditVehicleDocumentsModal
                        isOpen={otherDocumentShow}
                        onClose={(e) => setOtherDocumentShow(false)}
                        callListApi={() => getDataVehicleDocumentList()}
                    />
                }
            </div>
            <div className={otherDocumentShow ? 'offBack_drop' : ''}></div>

            {
                isDelete?.company_id && (
                    <CommonModal {...propsObject}>
                        <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
                    </CommonModal>
                )
            }
        </>
    )
}

export default VehicleDocuments